<template>
  <div class="slash-menu flex flex-col px-4 py-2 gap-y-4" :style="position">
    <div
      v-for="(item, index) in items"
      :key="item.id"
      class="slash-menu-item"
      :class="{ 'is-selected': index === selectedIndex, 'is-disabled': item.disabled || (item.matchType === 'variable' && (item.currentValue === null || item.currentValue === undefined)) }"
      @click="!(item.disabled || (item.matchType === 'variable' && (item.currentValue === null || item.currentValue === undefined))) && $emit('select', item)"
      @mouseenter="$emit('hover', index)"
    >
      <div v-if="item.icon" class="slash-menu-icon">
        <img :src="item.icon" :alt="item.label" class="slash-menu-icon-img" />
      </div>
      <div class="slash-menu-content">
        <div class="slash-menu-label">{{ item.label }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  selectedIndex: {
    type: Number,
    default: 0,
  },
  position: {
    type: Object,
    default: () => ({}),
  },
});

defineEmits(["select", "hover"]);
</script>

<style scoped>
.slash-menu {
  position: fixed;
  z-index: 99999;
  background: #FFFEF8;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  min-width: 240px;
  max-width: 320px;
  max-height: 320px;
  overflow-y: auto;
}

.slash-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 24px;
  cursor: pointer;
  transition: background-color 0.1s ease;
  padding:2px 4px;
}

.slash-menu-item:hover,
.slash-menu-item.is-selected {
  background-color: rgba(30, 70, 112, 0.08);
}

.slash-menu-item.is-disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.slash-menu-item.is-disabled:hover {
  background-color: transparent;
}

.slash-menu-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.slash-menu-icon-img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.slash-menu-icon-fallback {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.slash-menu-content {
  flex: 1;
  min-width: 0;
}

.slash-menu-label {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 1.3;
}
</style>
